module.exports = __webpack_public_path__ + "static/media/snake.4aeccc1a.jpg";